import { useMemo } from "react";
import jsonLogic from "json-logic-js";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useMerchantUiConfig } from "lib/contexts/MerchantUIConfigProvider";

export const useJsonPermission = () => {
  const {
    state: { rawCheckoutObject },
  } = useCheckoutContext();
  const {
    state: { cartUIAttributes },
  } = useMerchantUiConfig();

  const cartPermissions = useMemo(() => {
    const checkoutBtnStatus: string = jsonLogic.apply(
      cartUIAttributes?.primary_cta_disability_rule ?? "",
      rawCheckoutObject,
    );

    return {
      checkoutBtnStatus: Object.keys(checkoutBtnStatus).length === 0 ? "" : checkoutBtnStatus,
    };
  }, [rawCheckoutObject, cartUIAttributes]);

  return {
    cartPermissions,
  };
};
